import { logUsage } from 'owa-analytics';

export function logUsageAfterGetSharingInfo(
    shouldBeautifyLink: boolean,
    isValidResponse: boolean,
    hasValidFileName: boolean,
    shouldRehydrate: boolean
) {
    if (shouldBeautifyLink && isValidResponse && hasValidFileName) {
        logUsage('AttachmentComposeSPLinksBeautified');
    }

    if (shouldRehydrate) {
        logUsage('AttachmentComposeSPLinksRehydrated');
    }

    if (isValidResponse && !hasValidFileName) {
        logUsage('AttachmentComposeSPLinksResponseHasInvalidFileName');
    }
}
